/**
 * Loading placeholder for the onboarding detail page. Mirrors the real custom
 * (non-Polaris) layout — back link, name + status header, the step progress
 * bar, and a few info card blocks with field grids — so the page doesn't jump
 * once the onboarding loads, instead of a bare spinner.
 */
export default function OnboardingViewSkeleton() {
  return (
    <div className="px-6 py-4 animate-pulse" aria-hidden="true">
      {/* back link + header */}
      <div className="mb-6">
        <div className="h-4 w-24 bg-gray-200 rounded mb-3" />
        <div className="flex items-center gap-3">
          <div className="h-7 w-56 bg-gray-200 rounded" />
          <div className="h-5 w-28 bg-gray-100 rounded-full" />
        </div>
      </div>

      {/* step progress bar */}
      <div className="bg-white rounded-lg border border-gray-200 p-3 shadow-sm mb-4">
        <div className="flex items-center gap-2 flex-wrap">
          {Array.from({ length: 5 }).map((_, i) => (
            <div key={i} className="h-9 w-24 bg-gray-100 rounded-lg" />
          ))}
        </div>
      </div>

      {/* info card blocks */}
      {Array.from({ length: 3 }).map((_, i) => (
        <div
          key={i}
          className="bg-white rounded-lg border border-gray-200 p-5 shadow-sm mb-4"
        >
          <div className="h-5 w-40 bg-gray-200 rounded mb-4" />
          <div className="flex gap-10 flex-wrap">
            {Array.from({ length: 6 }).map((_, j) => (
              <div key={j} className="flex flex-col gap-2">
                <div className="h-3 w-20 bg-gray-100 rounded" />
                <div className="h-4 w-28 bg-gray-200 rounded" />
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
